<script>
	import { onDestroy, onMount } from 'svelte';

	let ref;

	onMount(() => {
		document.body.children[0].appendChild(ref);
	});

	onDestroy(() => {
		if (ref) {
			document.body.children[0].removeChild(ref);
		}
	});
</script>

<div class="portal-wrapper">
	<div class="portal" bind:this={ref}>
		<slot />
	</div>
</div>

<style lang="scss">
	.portal-wrapper {
		position: absolute;
	}
</style>
